import { getLabel } from '@weapp/utils';
import { controlCountryCodeFc } from '../utils'

export const getPhoneFieldData = (): any => {
  return [
    {
      cn: getLabel('93608', '中国'),
      en: 'China',
      code: '86'
    },
    {
      cn: getLabel('93609', '中国台湾'),
      en: 'TaiWan',
      code: '866'
    },
    {
      cn: getLabel('93610', '中国香港'),
      en: 'Hong Kong',
      code: '852'
    },
    {
      cn: getLabel('93611', '中国澳门'),
      en: 'Macau',
      code: '853'
    },
    {
      cn: getLabel('93612', '英国'),
      en: 'United Kingdom',
      code: '44'
    },
    {
      cn: getLabel('93613', '法国'),
      en: 'France',
      code: '33'
    },
    {
      cn: getLabel('93614', '美国'),
      en: 'United States',
      code: '1'
    },
    {
      cn: getLabel('93615', '加拿大'),
      en: 'Canada',
      code: '1'
    },
    {
      cn: getLabel('93616', '俄罗斯'),
      en: 'Russia',
      code: '7'
    },
    {
      cn: getLabel('93617', '德国'),
      en: 'Germany',
      code: '49'
    },
    {
      cn: getLabel('93618', '日本'),
      en: 'Japan',
      code: '81'
    },
    {
      cn: getLabel('93619', '韩国'),
      en: 'South Korea',
      code: '82'
    },
    {
      cn: getLabel('93620', '澳大利亚'),
      en: 'Australia',
      code: '61'
    },
    {
      cn: getLabel('93622', '印度'),
      en: 'India',
      code: '91'
    },
    {
      cn: getLabel('158186', '泰国'),
      en: 'Thailand',
      code: '66'
    },
    {
      cn: getLabel('158187', '新加坡'),
      en: 'Singapore',
      code: '65'
    },
    {
      cn: getLabel('158188', '马来西亚'),
      en: 'Malaysia',
      code: '60'
    },
    {
      cn: getLabel('158189', '菲律宾'),
      en: 'the Philippines',
      code: '63'
    },
  ]
}


export const getDefaultSkinData = (type: string) => {
  return {
    eb: {

    },
    public: {
      "modeId": 3,
      "payModule": true,
      "loginBoxOpacity": "100",
      // "imageUrl": "../static/img/logindesign/pic/bg_1.jpg",
      "topNavigationSwitch": "on",
      "thirdLoginSwitch": "on",
      "copyrightSwitch": "on",
      "navigationSwitch": "on",
      "serviceSwitch": "on",
      // "pcRightPic": "http://weapp.develop.cn/static/img/custom/pic/bg_1.jpg",//右侧图片
      // "pcRightPicPop": "http://weapp.develop.cn/static/img/custom/pic/bg_1.jpg",//右侧滑过显示图片
      // "pcBgType": "picture",
      "pcBgType": "picture",
      "pcBgVideo": "",
      "enterpriseNamePic": "word",
      // "pcRightPicSwitch": "on",
      "backgrounds": [
        // {
        //   "id": "5817050450861357803",
        //   "skinId": "5817050450860557795",
        //   "imageUrl": "/static/img/logindesign/pic/bg_1.jpg",
        //   "imagePassportUrl": "/static/img/custom/pic/bg_1.jpg",
        //   "status": "check",
        //   "type": "default",
        //   "createTime": 1570504509000,
        //   "useType": "pc"
        // }
      ],
      "pageInfo": {
        "allowQrLogin": 1,
        "allowRememberAccount": 1
      },
      "cusinfos": [
        {
          "infoType": "navigationMenu",
          "useType": "pc",
          "content": getLabel('158402', '首页'),
          "contentHref": "https://eteams.cn"
        },
        {
          "infoType": "navigationMenu",
          "useType": "pc",
          "content": getLabel('158403', '产品'),
          "contentHref": "https://eteams.cn/product"
        },
        {
          "infoType": "navigationMenu",
          "useType": "pc",
          "content": getLabel('158404', '移动'),
          "contentHref": "https://eteams.cn/mobile"
        },
        {
          "infoType": "navigationMenu",
          "useType": "pc",
          "content": getLabel('158405', '合作'),
          "contentHref": "https://eteams.cn/cooperation"
        },
        {
          "infoType": "navigationMenu",
          "useType": "pc",
          "content": getLabel('158406', '博客'),
          "contentHref": "https://eteams.cn/blog"
        },
        {
          "infoType": "navigationMenu",
          "useType": "pc",
          "content": getLabel('158407', '帮助'),
          "contentHref": "https://eteams.cn/help"
        },
        {
          "infoType": "bottomContent",
          "useType": "pc",
          "content": `Copyright © 2001-${new Date().getFullYear()} Weaver Network All Rights Reserved.`,
        },
        {
          "infoType": "bottomContent",
          "useType": "pc",
          "content": getLabel('159816', '沪ICP备05040488号-9'),
          "contentHref": "https://beian.miit.gov.cn/"
        }
      ]
    },
    public_h5: {
      "modeId": 0,
      "thirdLoginSwitch": "on",
      "copyrightSwitch": "on",
      "h5LogoWord": getLabel('159795', '泛微旗下云办公平台'),
      "payModule": true,
      "logoHref": 'https://eteams.cn',
      "h5BottomWord": `Copyright © 2001-${new Date().getFullYear()} Weaver Network All Rights Reserved.`,
      "h5AgreementName": getLabel('159796', '用户隐私政策协议'),
      "h5PrivacyAgreementSwitch": "on",
      "h5AgreementHref": 'https://emobile.weaver.com.cn/eteamsprivacypolicy.html'
    },
    private_h5: {
      "modeId": 0,
      "thirdLoginSwitch": "off",
      "copyrightSwitch": "off",
      "h5LogoWord": getLabel('159797', '泛微数字化运营平台'),
      "payModule": true,
      "logoHref": 'https://eteams.cn',
      "h5BottomWord": `Copyright © 2001-${new Date().getFullYear()} Weaver Network All Rights Reserved.`,
      "h5AgreementName": getLabel('159798', 'E-Mobile用户隐私政策协议'),
      "h5PrivacyAgreementSwitch": "on",
      "appServerChangeSwitch": "off",
      "h5AgreementHref": 'https://emobile.weaver.com.cn/eteamsprivacypolicy.html'
    },
    private: {
      "modeId": 2,
      "payModule": true,
      "loginBoxOpacity": "40",
      "imageUrl": "/static/img/custom/pic/bg_6.jpg",
      "topNavigationSwitch": "off",
      "thirdLoginSwitch": "off",
      "copyrightSwitch": "off",
      "navigationSwitch": "off",
      "serviceSwitch": "on",
      "serverChangeSwitch": "on",
      "pcRightPic": "",
      "pcRightPicPop": "",
      "pcBgType": "picture",
      "pcBgVideo": "",
      "enterpriseNamePic": "",
      "pcRightPicSwitch": "on",
      "pageInfo": {
        "allowQrLogin": 1,
        "allowRememberAccount": 1
      },
      "backgrounds": [
        {
          "id": "5817050450861357803",
          "skinId": "5817050450860557795",
          "imageUrl": "/static/img/custom/pic/bg_6.jpg",
          "imagePassportUrl": "/static/img/custom/pic/bg_6.jpg",
          "status": "check",
          "type": "default",
          "createTime": 1570504509000,
          "useType": "pc"
        }
      ],
      "cusinfos": [
        {
          "infoType": "navigationMenu",
          "useType": "pc",
          "content": getLabel('158402', '首页'),
          "contentHref": "https://eteams.cn"
        },
        {
          "infoType": "navigationMenu",
          "useType": "pc",
          "content": getLabel('158403', '产品'),
          "contentHref": "https://eteams.cn/product"
        },
        {
          "infoType": "navigationMenu",
          "useType": "pc",
          "content": getLabel('158404', '移动'),
          "contentHref": "https://eteams.cn/mobile"
        },
        {
          "infoType": "navigationMenu",
          "useType": "pc",
          "content": getLabel('158405', '合作'),
          "contentHref": "https://eteams.cn/cooperation"
        },
        {
          "infoType": "navigationMenu",
          "useType": "pc",
          "content": getLabel('158406', '博客'),
          "contentHref": "https://eteams.cn/blog"
        },
        {
          "infoType": "navigationMenu",
          "useType": "pc",
          "content": getLabel('158407', '帮助'),
          "contentHref": "https://eteams.cn/help"
        },
        {
          "infoType": "bottomContent",
          "useType": "pc",
          "content": `Copyright © 2001-${new Date().getFullYear()} Weaver Network All Rights Reserved.`,
        },
        {
          "infoType": "bottomContent",
          "useType": "pc",
          "content": getLabel('159816', '沪ICP备05040488号-9'),
          "contentHref": "https://beian.miit.gov.cn/"
        }
      ]
    }
  }[type]
}

